import API from '../../../api';
import FormStep from '../../Form/FormStep';

export default {
	mixins: [FormStep],
	props: {
		currentUser: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			formData: {
			},
			success: false,
			waitName: 'updateUser',
		};
	},
	methods: {
		submit() {
			this.$validator.validateAll().then((result) => {
				this.success = false;

				if(result) {
					this.$wait.start(this.waitName);

					this.save().then(() => {
						this.success = true;

						document.getElementById('content').scrollTo({
							top: 0,
							left: 0,
							behavior: 'smooth'
						});
					}).catch(error => {
						API.mapServerValidation(error.response, this.$validator);
					}).finally(() => {
						this.$wait.end(this.waitName);
					});
				}
			});
		},
		save() {
			return Promise.reject('Not implemented');
		}
	},
}
